import { Block } from '../../../services/entities/impl/blfApi/schemas/block';
import { convertBlocksToFeatureCollection } from './convertBlocksToFeatureCollection';
import { getBoundsFromFeatureCollection } from './getBoundsFromFeatureCollection';

/**
 * Calculates the bounding box for a given set of blocks.
 *
 * The function takes an array of blocks, each containing geographical information, and
 * calculates the minimum bounding rectangle that contains all the blocks. The function
 * will ignore blocks that don't have a 'geoPolygon' property.
 *
 * The resulting bounding box is represented as an instance of LngLatBounds, which has
 * two corners represented by LngLat coordinates. If the input array is empty or no blocks
 * have a 'geoPolygon', or if the resulting bounding box has non-numeric coordinates, the
 * function returns null.
 *
 * @param {Block[] | undefined} blocksFiltered - The array of blocks for which to calculate
 * the bounding box. Each block is expected to have a 'geoPolygon' property, which is a
 * GeoJSON FeatureCollection of Geometry objects.
 *
 * @returns {LngLatBoundsLike | null} - The minimum bounding box containing all blocks, or null
 * if it was impossible to calculate a bounding box.
 */
export const getBoundsFromBlocks = (blocksFiltered: Block[] | undefined) => {
  if (!blocksFiltered) {
    return null;
  }
  return getBoundsFromFeatureCollection(
    convertBlocksToFeatureCollection(blocksFiltered)
  );
};
